/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Link, Typography } from "@mui/material";
import { environment } from "../../../../../Basis/environment";
import { Symbole } from "../../../Queries/Symbol";
import AppLink from "./../../../../../Basis/Components/AppLink";
import AppNotificationLinkProps from "./AppNotificationLinkProps";

export default function AppNotificationLink(props: AppNotificationLinkProps) {
    if (!props.item.typUrl || props.item.benachrichtigung.symbol === Symbole.laufend) {
        return (
            <Typography variant="body2">
                {props.item.benachrichtigung.matchcode}
            </Typography>
        );
    }

    if (props.item.urlIstDateiDownload) {
        return (
            <Link
                onClick={props.onClick}
                color="secondary"
                underline="hover"
                href={`${environment.uiBaseUrl}/${props.item.typUrl}`}
                download
            >
                {props.item.benachrichtigung.matchcode}
            </Link>
        );
    }

    return (
        <AppLink
            to={props.item.typUrl}
            onClick={props.onClick}
            target={props.item.urlInNeuemTabOeffnen ? "_blank" : "_self"}
        >
            {props.item.benachrichtigung.matchcode}
        </AppLink>
    );
}